import { useEffect, useRef, useState } from "react";
import Button from "./Button";
import Heading from "./Heading";
import TagHeading from "./TagHeading";


const differentData = [
  {
    id: "one",
    title: "Behavioural & Psychological Insight",
    label: "We study leadership at a deeper level through:",
    desc: "Through structured behavioural interviews, leadership diagnostics, and decision-pattern analysis, we uncover the traits that drive long-term success.",
    points: [
      "How leaders think",
      "How leaders decide",
      "How leaders influence",
      "How leaders collaborate",
      "How leaders respond to complexity"
    ],
    img: "/img/assets/home/behavioural-and-psychological-insight.webp",
  },
  {
    id: "two",
    title: "Strength-Based & Potential-Centric Evaluation",
    label: "Every leader has natural talents that define how they lead. We identify these core capabilities through:",
    desc: "This helps us understand their ability to scale, inspire, and drive future performance — not just replicate past achievements.",
    points: [
      "Core strengths",
      "Innate patterns",
      "Growth potential"
    ],
    img: "/img/assets/home/strength-based-and-potential-centric-evaluation.webp",
  },
  {
    id: "three",
    title: "Market-Forward Talent Intelligence",
    label: "We bring sharp industry insight through:",
    desc: "This helps us position your role strategically and attract leaders who can thrive in evolving business environments.",
    points: [
      "Leadership trends",
      "Competitor talent mapping",
      "Compensation benchmarks",
      "Emerging CXO archetypes"
    ],
    img: "/img/assets/home/discovery-and-alignment.webp",
  },
  {
    id: "four",
    title: "Culture-First Leadership Selection",
    label: "Hiring the right leader means hiring someone who amplifies your culture, not disorders it. Our Culture Fit Index evaluates alignment on:",
    desc: "Ensuring seamless integration.",
    points: [
      "Values",
      "Energy",
      "Decision style",
      "Leadership philosophy",
      "Team impact"
    ],
    img: "/img/assets/home/discovery-and-alignment.webp",
  },
  {
    id: "fiv",
    title: "End-to-End Leadership Integration",
    label: "Our role doesn’t end with the offer. We support leaders through:",
    desc: "This ensures leaders not only join — they accelerate impact from day one.",
    points: [
      " Onboarding readiness",
      " Onboarding readiness",
      "Stakeholder alignment",
      "30–60–90 day integration",
      "Early assimilation check-ins"
    ],
    img: "/img/assets/home/discovery-and-alignment.webp",
  }
];

export default function Different() {

  const [activeOne, setActiveOne] = useState("one");

  const sectionRefsOne = useRef({});
  useEffect(() => {
    // const observer = new IntersectionObserver(
    //   (entries) => {
    //     entries.forEach((entry) => {
    //       if (entry.isIntersecting) {
    //         setActiveOne(entry.target.id);
    //       }
    //     });
    //   },
    //   { threshold: 0.6 }
    // );
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveOne(entry.target.id);
          }
        });
      },
      {
        threshold: 0.6,
        rootMargin: "-200px 0px -20% 0px"
      }
    );
    Object.values(sectionRefsOne.current).forEach((section) =>
      observer.observe(section)
    );
    return () => observer.disconnect();
  }, []);
  const scrollToSectionOne = (id) => {
    sectionRefsOne.current[id]?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="bg-[#F6F8FB] py-24">
      <div className="mx-auto w-full 2xl:w-[80%] xl:w-11/12 px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 pb-10 mb-16 lg:sticky z-10 top-20 bg-[#F6F8FB]">
          <div className="bg-[#F6F8FB]">
            <TagHeading className="textactive" text="The Different" />
            <Heading className="textblack" text="What Makes Us Different" />
            <p className="md:text-lg text-base font-semibold textblack mt-5">We don’t just search for leaders — We discover the ones who can shape your future.</p>
          </div>
          <div className="flex flex-col justify-center">
            <p className="textblack text-lg mb-6">
              GregandAllen Executive Search stands apart because we evaluate
              leaders through a <span className="font-semibold">science-backed, strengths-driven, and
                culture-focused lens</span>. Our approach blends behavioural science,
              leadership psychology, and organizational insight to deliver
              leaders who are not just suitable — <span className="font-semibold">but transformational.</span>
            </p>
            {/* <div className="flex justify-center md:justify-start items-center md:items-center gap-4 md:w-64 w-full">
              <Button text="Explore More" />
            </div> */}
          </div>
        </div>


        {/* DESKTOP VIEW */}
        <div className="hidden lg:flex gap-16 items-start">
          {/* LEFT TABS */}
          <div className="sticky top-80 w-1/2 flex flex-col">
            {differentData.map((tab) => (
              <div
                key={tab.id}
                onClick={() => scrollToSectionOne(tab.id)}
                className={`cursor-pointer px-5 pb-8 last:pb-0 border-l-4 transition-all duration-300
                  ${activeOne === tab.id
                    ? "border-red-600 textblack"
                    : "border-red-200 textgray"
                  }`}
              >
                <h1 className="md:text-xl text-lg font-semibold">{tab.title}</h1>
                {activeOne === tab.id && (
                  <>
                    <p className="py-3 text-base textblack">{tab.label}</p>
                    <ul className="space-y-2 list-disc ml-8 textblack">
                      {tab.points.map((point, index) => (
                        <li key={index}>{point}</li>
                      ))}
                    </ul>
                    <p className="pt-3 text-base textblack">{tab.desc}</p>
                  </>
                )}
              </div>
            ))}
          </div>

          {/* RIGHT IMAGES */}
          <div className="flex-1">
            {differentData.map((tab) => (
              // <section
              //   key={tab.id}
              //   id={tab.id}
              //   ref={(el) => (sectionRefsOne.current[tab.id] = el)}
              //   className="min-h-[50vh] flex items-center mb-32"
              // >
              <section
                key={tab.id}
                id={tab.id}
                ref={(el) => (sectionRefsOne.current[tab.id] = el)}
                className="min-h-[53vh] flex items-center mb-32 scroll-mt-[280px]"
              >
                <img
                  src={tab.img}
                  alt={tab.title}
                  className="w-full rounded-2xl"
                />
              </section>
            ))}
          </div>
        </div>

        {/* MOBILE VIEW */}
        <div className="lg:hidden space-y-20">
          {differentData.map((tab) => (
            <div key={tab.id} className="space-y-6">
              <h2 className="text-xl font-semibold textblack">
                {tab.title}
              </h2>

              <div className="space-y-3">
                <p className="text-base textblack">{tab.label}</p>
                <ul className="list-disc ml-8 space-y-2 textblack">
                  {tab.points.map((point, index) => (
                    <li key={index}>{point}</li>
                  ))}
                </ul>
                <p className="text-base textblack">{tab.desc}</p>
              </div>

              <img
                src={tab.img}
                alt={tab.title}
                className="w-full rounded-2xl shadow-lg"
                loading="lazy"
              />
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}
